// @flow
import * as React from "react"
import { FieldTitle } from "componentsStyled/Typography/Titles"
import { Relative } from "componentsStyled/Layout/Position"
import ToolTip from "components/ToolTip"
import type { ToolTipContent } from "data/tooltips/types"
import { InputWrapWrap, Error, MultiInputWrapWrap } from "./styled"

type Props = {|
  children: React.Element<*>,
  error: ?string,
  label: ?string,
  errorPosition: ?string,
  toolTip?: ToolTipContent | string,
  noMargin?: boolean,
|}

const InputWrap = ({ children, label, error, errorPosition, toolTip, noMargin }: Props) => {
  const unit = children.props.unit
  const isArray = Array.isArray(unit)
  const withToolTip = toolTip ? true : false

  if (isArray) {
    return (
      <MultiInputWrapWrap>
        {label && <FieldTitle>{label}</FieldTitle>}
        <Relative>{children}</Relative>
        {error && <Error errorPosition={errorPosition}>{error}</Error>}
      </MultiInputWrapWrap>
    )
  }

  return (
    <InputWrapWrap noMargin={noMargin}>
      {label &&
        <FieldTitle inline={withToolTip}>{label}</FieldTitle>
      }
      {toolTip &&
        <ToolTip content={toolTip}></ToolTip>
      }
      <Relative>{children}</Relative>
      {error && <Error errorPosition={errorPosition}>{error}</Error>}
    </InputWrapWrap>
  )
}

export default InputWrap



// WEBPACK FOOTER //
// ./src/forms/withFormField/InputWrap/index.js